/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * @ignore
 * Makes sure that GeopolView object returns the same view code as provided in constructor. It means that this is a
 * correct view code because otherwise GeopolView would fallback to default one.
 */
define(['./geopolView'], function(GeopolView) {
    'use strict';
    return function(geopolViewCode) {
        var geopolView = new GeopolView(geopolViewCode);
        return geopolView.getCode() === geopolViewCode;
    };
});



// WEBPACK FOOTER //
// ./config/geopolView/validator.js